<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-md-8 offset-3">
              <VueFaqAccordion
                  :items="myItems"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from "@state/http";
import VueFaqAccordion from 'vue-faq-accordion'

export default {
  page: {
    title: 'FAQ',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueFaqAccordion },
  data() {
    return {
      title: 'FAQ',
      items: [
        {
          text: 'FAQ',
          active: true,
        },
      ],
      myItems: [
        {
          title: 'EP ID: 1291010910005',
          value: '- Ex: (1-paid/2-not paid) 1(Paid), 29-(District, Faridpur), 10-(Upazila, Bhanga), 109-(Union, 7 No Algi), 10005-(Form no)',
          category: 'Frequently Asked Questions'
        },
      ]
    }
  },

  mounted() {},
  methods: {},
}
</script>
<style>
  .accordion__title{
    padding: 15px !important;
  }
  .accordion{
    border-radius: 2px !important;
    border: 2px solid #000000a1 !important;
  }

  .faq__nav{
    border-radius: 2px !important;
    border: 2px solid #000000a1 !important;
  }

  .faq__nav-item{
    height: 50px !important;
  }
</style>
